export enum EnumConvenioTpFaturaStatus {
    Aberta,
    Fechada,
    Paga,
    NaoPaga
}